import script from "./NavigationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBar.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=05ae45ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ae45ec"]])

export default __exports__